module.exports = __webpack_public_path__ + "static/media/KT_Meta_Headshot_Copy.8405f14d.png";